export const API_INFO_ANDROID = {
  APIS: [
    {
      module: 'appinfo',
      api: 'PackageManager#getInstalledPackages(int)',
      shortName: 'PM#G_IN_PKGS',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '已安装应用',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'PACKAGES',
      lx_description: '已安装应用列表',
      apiConstant: 'ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_INSTALLED_PACKAGES',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_INSTALLED_PACKAGES).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'appinfo',
      api: 'android.content.Context#registerReceiver(BroadcastReceiver, IntentFilter)',
      shortName: 'CON#RR',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '已安装应用',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.CONTEXT_REGISTER_RECEIVER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.CONTEXT_REGISTER_RECEIVER).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'appinfo',
      api: 'PackageManager#getInstalledApplications(int)',
      shortName: 'PM#G_IN_APPS',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '已安装应用',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'PACKAGES',
      lx_description: '已安装应用列表',
      apiConstant: 'ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_INSTALLED_APPLICATIONS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_INSTALLED_APPLICATIONS).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'appinfo',
      api: 'ActivityManager#getRunningTasks(int)',
      shortName: 'AM#G_RN_TA',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '已安装应用',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_RUNNING_TASKS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_RUNNING_TASKS).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'appinfo',
      api: 'PackageManager#queryIntentServices(Intent, int)',
      shortName: 'PM#QUERY_INT_SERV',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '已安装应用',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'PACKAGES',
      lx_description: '已安装应用列表',
      apiConstant: 'ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.QUERY_INTENT_SERVICES',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.QUERY_INTENT_SERVICES).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'appinfo',
      api: 'PackageManager#getLaunchIntentForPackage(String)',
      shortName: 'PM#G_LAU_INT_FOR_PKG',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '已安装应用',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_LAUNCH_INTENT_FOR_PACKAGE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_LAUNCH_INTENT_FOR_PACKAGE).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'appinfo',
      api: 'ActivityManager#getRunningAppProcesses()',
      shortName: 'AM#G_RN_A_PC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '已安装应用',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'RUNNING_APP_PROCESSES',
      lx_description: '运行中的进程',
      apiConstant: 'ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_RUNNING_APP_PROCESS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_RUNNING_APP_PROCESS).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'appinfo',
      api: 'PackageManager#getPackageInfo(String, int)',
      shortName: 'PM#G_PKG_INFO_N',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '已安装应用',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_PACKAGE_INFO_WITH_NAME',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_PACKAGE_INFO_WITH_NAME).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'appinfo',
      api: 'PackageManager#getPackageInfo(VersionedPackage, int)',
      shortName: 'PM#G_PKG_INFO_VP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '已安装应用',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_PACKAGE_INFO_WITH_VP',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.GET_PACKAGE_INFO_WITH_VP).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'appinfo',
      api: 'PackageManager#queryIntentActivities(Intent, int)',
      shortName: 'PM#QUERY_INT_ACT',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '已安装应用',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'PACKAGES',
      lx_description: '已安装应用列表',
      apiConstant: 'ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.QUERY_INTENT_ACTIVITIES',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.InstalledAppList.NAME, ConstantModel.InstalledAppList.QUERY_INTENT_ACTIVITIES).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'boot',
      api: 'android.content.Context#startActivity(Intent)',
      shortName: 'C#SA',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '启动模块',
      configStrategies: [
        'normal',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Boot.NAME, ConstantModel.Boot.SA',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Boot.NAME, ConstantModel.Boot.SA).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'camera',
      api: 'MediaRecorder#setVideoSource(int)',
      shortName: 'MR#SET_VID_SRC#I',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '摄像头',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'START_RECORD_VIDEO',
      lx_description: '开始录像',
      apiConstant: 'ConstantModel.Camera.NAME, ConstantModel.Camera.SET_VIDEO_SOURCE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Camera.NAME, ConstantModel.Camera.SET_VIDEO_SOURCE).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'camera',
      api: 'android.hardware.Camera#open(int)',
      shortName: 'CAM#OPN#I',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '摄像头',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'OPEN_CAMERA',
      lx_description: '相机',
      apiConstant: 'ConstantModel.Camera.NAME, ConstantModel.Camera.OPEN_PARAM_I',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Camera.NAME, ConstantModel.Camera.OPEN_PARAM_I).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'camera',
      api: 'CameraManager#openCamera(String, Executor, StateCallback)',
      shortName: 'CAMM#OPN_CAM#SES',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '摄像头',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'OPEN_CAMERA',
      lx_description: '相机',
      apiConstant: 'ConstantModel.Camera.NAME, ConstantModel.Camera.OPEN_CAMERA_PARAM_SES',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Camera.NAME, ConstantModel.Camera.OPEN_CAMERA_PARAM_SES).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'camera',
      api: 'android.hardware.Camera#open()',
      shortName: 'CAM#OPN',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '摄像头',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'OPEN_CAMERA',
      lx_description: '相机',
      apiConstant: 'ConstantModel.Camera.NAME, ConstantModel.Camera.OPEN',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Camera.NAME, ConstantModel.Camera.OPEN).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'camera',
      api: 'android.hardware.camera2.CameraDevice#createCaptureRequest(int)',
      shortName: 'CAMDVC#CCR#I',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '摄像头',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'OPEN_CAMERA',
      lx_description: '相机',
      apiConstant: 'ConstantModel.Camera.NAME, ConstantModel.Camera.CREATE_CAPTURE_REQ',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Camera.NAME, ConstantModel.Camera.CREATE_CAPTURE_REQ).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'camera',
      api: 'CameraManager#openCamera(String, StateCallback, Handler)',
      shortName: 'CAMM#OPN_CAM#SCH',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '摄像头',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'OPEN_CAMERA',
      lx_description: '相机',
      apiConstant: 'ConstantModel.Camera.NAME, ConstantModel.Camera.OPEN_CAMERA_PARAM_SCH',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Camera.NAME, ConstantModel.Camera.OPEN_CAMERA_PARAM_SCH).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'camera',
      api: 'android.hardware.camera2.CameraCaptureSession#setRepeatingRequest(CaptureRequest,CameraCaptureSession.CaptureCallback,Handler )',
      shortName: 'CAMCS#SRR#CCH',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '摄像头',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Camera.NAME, ConstantModel.Camera.SET_REPEATING_REQUEST',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Camera.NAME, ConstantModel.Camera.SET_REPEATING_REQUEST).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'camera',
      api: 'android.hardware.Camera#takePicture(ShutterCallback, PictureCallback, PictureCallback, PictureCallback)',
      shortName: 'CAM#TAKE_PIC#SPPP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '摄像头',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'OPEN_CAMERA',
      lx_description: '相机',
      apiConstant: 'ConstantModel.Camera.NAME, ConstantModel.Camera.TAKE_PICTURE_SPPP',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Camera.NAME, ConstantModel.Camera.TAKE_PICTURE_SPPP).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'camera',
      api: 'android.hardware.camera2.CameraDevice#createCaptureRequest(int, Set)',
      shortName: 'CAMDVC#CCR#IS',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '摄像头',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'OPEN_CAMERA',
      lx_description: '相机',
      apiConstant: 'ConstantModel.Camera.NAME, ConstantModel.Camera.CREATE_CAPTURE_REQ_IS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Camera.NAME, ConstantModel.Camera.CREATE_CAPTURE_REQ_IS).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'camera',
      api: 'android.hardware.Camera#takePicture(ShutterCallback, PictureCallback, PictureCallback)',
      shortName: 'CAM#TAKE_PIC#SPP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '摄像头',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'OPEN_CAMERA',
      lx_description: '相机',
      apiConstant: 'ConstantModel.Camera.NAME, ConstantModel.Camera.TAKE_PICTURE_SPP',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Camera.NAME, ConstantModel.Camera.TAKE_PICTURE_SPP).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'clipboard',
      api: 'ClipboardManager#getPrimaryClip()',
      shortName: 'CM#G_PRI_DESC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '剪贴板',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'CLIPBOARD',
      lx_description: '剪切板',
      apiConstant: 'ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.GET_PRIMARY_CLIP',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.GET_PRIMARY_CLIP).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'clipboard',
      api: 'ClipboardManager#clearPrimaryClip()',
      shortName: 'CM#CL_PRI_CLIP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '剪贴板',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.CLEAR_PRIMARY_CLIP',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.CLEAR_PRIMARY_CLIP).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'clipboard',
      api: 'ClipboardManager#getText()',
      shortName: 'CM#G_TXT',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '剪贴板',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'CLIPBOARD',
      lx_description: '剪切板',
      apiConstant: 'ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.GET_TEXT',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.GET_TEXT).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'clipboard',
      api: 'ClipboardManager#hasText()',
      shortName: 'CM#HAS_TXT',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '剪贴板',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.HAS_TEXT',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.HAS_TEXT).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'clipboard',
      api: 'ClipboardManager#hasPrimaryClip()',
      shortName: 'CM#HAS_PRI_CLIP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '剪贴板',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.HAS_PRIMARY_CLIP',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.HAS_PRIMARY_CLIP).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'clipboard',
      api: 'ClipboardManager#removePrimaryClipChangedListener(ClipboardManager.OnPrimaryClipChangedListener)',
      shortName: 'CM#REM_CLIP_LIS',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '剪贴板',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'REMOVE_CLIPBOARD_LISTENER',
      lx_description: '停止监控剪切板',
      apiConstant: 'ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.REMOVE_CLIP_CHANGED_LISTENER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.REMOVE_CLIP_CHANGED_LISTENER).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'clipboard',
      api: 'ClipboardManager#setText(CharSequence)',
      shortName: 'CM#SET_TXT',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '剪贴板',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.SET_TEXT',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.SET_TEXT).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'clipboard',
      api: 'ClipboardManager#setPrimaryClip(ClipData)',
      shortName: 'CM#SET_PRI_CLIP#C',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '剪贴板',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.SET_PRIMARY_CLIP',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.SET_PRIMARY_CLIP).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'clipboard',
      api: 'ClipboardManager#addPrimaryClipChangedListener(ClipboardManager.OnPrimaryClipChangedListener)',
      shortName: 'CM#AD_CLIP_LIS',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '剪贴板',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'ADD_CLIPBOARD_LISTENER',
      lx_description: '开始监控剪切板',
      apiConstant: 'ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.ADD_CLIP_CHANGED_LISTENER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.ADD_CLIP_CHANGED_LISTENER).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'clipboard',
      api: 'ClipboardManager#getPrimaryClipDescription()',
      shortName: 'CM#G_PRI_CLIP_DESC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '剪贴板',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.GET_PRIMARY_CLIP_DESCRIPTION',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Clipboard.NAME, ConstantModel.Clipboard.GET_PRIMARY_CLIP_DESCRIPTION).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'contact',
      api: 'ContentResolver#query(Uri, String[], Bundle, CancellationSignal)',
      shortName: 'CR#QUERY_CON#U[SBC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '通讯录',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'CONTACTS',
      lx_description: '通讯录',
      apiConstant: 'ConstantModel.Contacts.NAME, ConstantModel.Contacts.QUERY_PARAM_BUNDLE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Contacts.NAME, ConstantModel.Contacts.QUERY_PARAM_BUNDLE).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'contact',
      api: 'ContentResolver#query(Uri, String[], String, String[], String)',
      shortName: 'CR#QUERY_CON#U[SS[SS',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '通讯录',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'CONTACTS',
      lx_description: '通讯录',
      apiConstant: 'ConstantModel.Contacts.NAME, ConstantModel.Contacts.QUERY_PARAM_SORT_ORDER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Contacts.NAME, ConstantModel.Contacts.QUERY_PARAM_SORT_ORDER).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'contact',
      api: 'ContentResolver#query(Uri, String[], String, String[], String, CancellationSignal)',
      shortName: 'CR#QUERY_CON#U[SS[SSC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '通讯录',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'CONTACTS',
      lx_description: '通讯录',
      apiConstant: 'ConstantModel.Contacts.NAME, ConstantModel.Contacts.QUERY_PARAM_CANCEL_SIGNAL',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Contacts.NAME, ConstantModel.Contacts.QUERY_PARAM_CANCEL_SIGNAL).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getSimOperator()',
      shortName: 'TM#G_SIM_OP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SIM_OPERATOR',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SIM_OPERATOR).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getImei(int)',
      shortName: 'TM#G_IM#I',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_IMEI_PARAM_INDEX',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_IMEI_PARAM_INDEX).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'Build#MODEL',
      shortName: 'BU#MODEL',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'PHONE_MODEL',
      lx_description: '手机型号',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_MODEL',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_MODEL).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'OAID_XIAOMI_IdProviderImpl#getOAID()',
      shortName: 'OAID#XIAOMI',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'OAID',
      lx_description: 'OAID',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.OAID_XIAOMI',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.OAID_XIAOMI).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getNetworkOperator()',
      shortName: 'TM#G_NWK_OP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_NETWORK_OPERATOR',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_NETWORK_OPERATOR).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'OAID_HONOR_Global#getString(ContentResolver, String)',
      shortName: 'OAID#HONOR',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.OAID_HONOR',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.OAID_HONOR).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'OAID_HUAWEI_Global#getString(ContentResolver, String)',
      shortName: 'OAID#HUAWEI',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.OAID_HUAWEI',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.OAID_HUAWEI).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'Build#getSerial()',
      shortName: 'BU#SER',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'SERIAL',
      lx_description: '设备SN',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SERIAL',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SERIAL).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'SubscriptionManager#getActiveSubscriptionInfoForSimSlotIndex(int)',
      shortName: 'SUBM#G_ATIVE_SUB_FSSI#I',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '设备信息',
      configStrategies: [
        'normal',
      ],
      lx_module: 'IMSI',
      lx_description: 'IMSI',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_ACTIVE_SUB_INFO_SIM_PARAM_I',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_ACTIVE_SUB_INFO_SIM_PARAM_I).rule(GeneralRule.BACK_BAN_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'OAID_VIVO_CONTENTRESOLVER#query()',
      shortName: 'OAID#VIVO',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.OAID_VIVO',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.OAID_VIVO).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getSubscriberId(int)',
      shortName: 'TM#G_SID_I',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'IMSI',
      lx_description: 'IMSI',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SUBSCRIBER_ID_I',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SUBSCRIBER_ID_I).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getMeid()',
      shortName: 'TM#G_MID',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'MEID',
      lx_description: 'MEID',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_MEID',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_MEID).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getImei()',
      shortName: 'TM#G_IM',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'IMEI',
      lx_description: 'IMEI',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_IMEI',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_IMEI).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getSimSerialNumber()',
      shortName: 'TM#G_SIM_SE_NUM',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'ICCID',
      lx_description: 'ICCID',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SIM_SERIAL_NUMBER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SIM_SERIAL_NUMBER).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getSimState(int)',
      shortName: 'TM#G_SIM_S_I',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '设备信息',
      configStrategies: [
        'normal',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SIM_STATE_I',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SIM_STATE_I).rule(GeneralRule.BACK_BAN_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'SubscriptionManager#getActiveSubscriptionInfoList()',
      shortName: 'SM#G_ACTIVE_SUB_L',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '设备信息',
      configStrategies: [
        'normal',
      ],
      lx_module: 'ICCID',
      lx_description: 'ICCID',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_ACTIVE_SUB_INFO_LIST',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_ACTIVE_SUB_INFO_LIST).rule(GeneralRule.BACK_BAN_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getSubscriberId()',
      shortName: 'TM#G_SID',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'IMSI',
      lx_description: 'IMSI',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SUBSCRIBER_ID',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SUBSCRIBER_ID).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getUiccCardsInfo()',
      shortName: 'TM#G_UICC_INFO',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'ICCID',
      lx_description: 'ICCID',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_UICC_CARDS_INFO',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_UICC_CARDS_INFO).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getMeid(int)',
      shortName: 'TM#G_MID#I',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'MEID',
      lx_description: 'MEID',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_MEID_PARAM_INDEX',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_MEID_PARAM_INDEX).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getLine1Number()',
      shortName: 'TM#G_LI_NUM',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'PHONE_NUMBER',
      lx_description: '手机号码',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_LINE1_NUMBER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_LINE1_NUMBER).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'SubscriptionManager#getActiveSubscriptionInfo(int)',
      shortName: 'SUBM#G_ATIVE_SUB#I',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '设备信息',
      configStrategies: [
        'normal',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_ACTIVE_SUB_INFO_PARAM_I',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_ACTIVE_SUB_INFO_PARAM_I).rule(GeneralRule.BACK_BAN_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getSimState()',
      shortName: 'TM#G_SIM_S',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '设备信息',
      configStrategies: [
        'normal',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SIM_STATE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_SIM_STATE).rule(GeneralRule.BACK_BAN_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'SubscriptionManager#getOpportunisticSubscriptions()',
      shortName: 'SUBM#G_OPP_SUBS',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '设备信息',
      configStrategies: [
        'normal',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_OPP_SUBS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_OPP_SUBS).rule(GeneralRule.BACK_BAN_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'SubscriptionManager#getCompleteActiveSubscriptionInfoList()',
      shortName: 'SUBM#G_COMP_ACTIVE_SUB_L',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '设备信息',
      configStrategies: [
        'normal',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_COMP_ACTIVE_SUB_INFO_LIST',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_COMP_ACTIVE_SUB_INFO_LIST).rule(GeneralRule.BACK_BAN_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getDeviceId()',
      shortName: 'TM#G_DID',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'IMEI/MEID',
      lx_description: 'IMEI/MEID',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_DEVICE_ID',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_DEVICE_ID).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'TelephonyManager#getDeviceId(int)',
      shortName: 'TM#G_DID#I',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'IMEI/MEID',
      lx_description: 'IMEI/MEID',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_DEVICE_ID_PARAM_INDEX',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_DEVICE_ID_PARAM_INDEX).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'Settings.Secure#getString(ContentResolver, String)',
      shortName: 'SE#G_AID',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'AndroidID',
      lx_description: 'AndroidID',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_ANDROID_ID',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_ANDROID_ID).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'SubscriptionManager#getAccessibleSubscriptionInfoList()',
      shortName: 'SUBM#G_ACCESS_SUB_L',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '设备信息',
      configStrategies: [
        'normal',
      ],
      lx_module: 'ICCID',
      lx_description: 'ICCID',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_ACCESS_SUB_INFO_LIST',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.GET_ACCESS_SUB_INFO_LIST).rule(GeneralRule.BACK_BAN_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'device',
      api: 'OAID_OPPO_IBinder#transact()',
      shortName: 'OAID#OPPO',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '设备信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.OAID_OPPO',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.DeviceInfo.NAME, ConstantModel.DeviceInfo.OAID_OPPO).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'WifiManager#getConnectionInfo()',
      shortName: 'WM#G_CON_INFO',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'CONNECTED_WIFI',
      lx_description: '连接的Wi-Fi',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_CONNECT_INFO',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_CONNECT_INFO).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'GsmCellLocation#getCid()  CellIdentityGsm#getCid()',
      shortName: 'GCL#G_CID',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'CELL_INFO',
      lx_description: 'CellID',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_CID',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_CID).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'TelephonyManager#requestCellInfoUpdate(Executor, CellInfoCallback)',
      shortName: 'TM#REQ_CELL_UP#EC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_CELL_INFO_UPDATE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_CELL_INFO_UPDATE).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#requestLocationUpdates(long, float, Criteria, LocationListener, Looper)',
      shortName: 'LM#REQ_LOC_UP#LFCLL',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'LOCATION',
      lx_description: '位置',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_LOCATION_PARAM_CRITERIA',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_LOCATION_PARAM_CRITERIA).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'location',
      api: 'CellIdentityLte#getCi()',
      shortName: 'CIL#G_CI',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_CELL_LTE_CI',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_CELL_LTE_CI).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'BluetoothLeScanner#startScan(List, ScanSettings, ScanCallback)',
      shortName: 'BLS#STRT_SC#LSS',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.START_SCAN_PARAM_SETTINGS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.START_SCAN_PARAM_SETTINGS).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'BluetoothLeScanner#startScan(List, ScanSettings, PendingIntent)',
      shortName: 'BLS#STRT_SC#LSP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.START_SCAN_PARAM_INTENT',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.START_SCAN_PARAM_INTENT).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationProvider#requiresCell()',
      shortName: 'LP#REQ_CELL',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUIRES_CELL',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUIRES_CELL).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#requestSingleUpdate(Criteria, PendingIntent)',
      shortName: 'LM#REQ_SIN_UP#CP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_SINGLE_PARAM_C_INTENT',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_SINGLE_PARAM_C_INTENT).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'android.location.Location#getAccuracy()',
      shortName: 'LOC#G_ACC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_ACCURACY',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_ACCURACY).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'CdmaCellLocation#getBaseStationId()  CellIdentityCdma#getBasestationId()',
      shortName: 'CCL#G_BASE_STAT_ID',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'CELL_INFO',
      lx_description: 'CellID',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_BASE_STATION_ID',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_BASE_STATION_ID).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationProvider#requiresSatellite()',
      shortName: 'LP#REQ_SAT',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUIRES_SATE_LITE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUIRES_SATE_LITE).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'BluetoothAdapter#startLeScan(UUID[], LeScanCallback)',
      shortName: 'BA#STRT_LE_SC#UL',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.START_LE_SCAN_PARAM_UUID',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.START_LE_SCAN_PARAM_UUID).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#removeUpdates(LocationListener)',
      shortName: 'LM#RE_UP#L',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'REMOVE_LOCATION_LISTENER',
      lx_description: '停止获取位置信息',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REMOVE_UPDATES_LISTENER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REMOVE_UPDATES_LISTENER).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationProvider#requiresNetwork()',
      shortName: 'LP#REQ_NET',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUIRES_NETWORK',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUIRES_NETWORK).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#getLastKnownLocation(String)',
      shortName: 'LM#G_LAST_KL',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'LOCATION',
      lx_description: '位置',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_LAST_KNOWN_LOCATION',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_LAST_KNOWN_LOCATION).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'location',
      api: 'CellIdentityTdscdma#getCid()',
      shortName: 'CIT#G_CID',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_CELL_TDSCDMA_CID',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_CELL_TDSCDMA_CID).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#requestSingleUpdate(String, LocationListener, Looper)',
      shortName: 'LM#REQ_SIN_UP#SLL',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_SINGLE_PARAM_LOOPER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_SINGLE_PARAM_LOOPER).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#requestSingleUpdate(String, PendingIntent)',
      shortName: 'LM#REQ_SIN_UP#SP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_SINGLE_PARAM_INTENT',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_SINGLE_PARAM_INTENT).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#requestLocationUpdates(String, long, float, LocationListener, Looper)',
      shortName: 'LM#REQ_LOC_UP#SLFLL',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_LOCATION_PARAM_LOOPER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_LOCATION_PARAM_LOOPER).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'TelephonyManager#getServiceState()',
      shortName: 'TM#G_SER_STATE',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_SERVICE_STATE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_SERVICE_STATE).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'TelephonyManager#requestNetworkScan(NetworkScanRequest, Executor, NetworkScanCallback)',
      shortName: 'TM#REQ_NW_SC#REC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_NETWORK_SCAN',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_NETWORK_SCAN).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'BluetoothAdapter#startDiscovery()',
      shortName: 'BA#STRT_DIS_COV',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.START_DISCOVERY',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.START_DISCOVERY).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'android.location.Location#getLongitude()',
      shortName: 'LOC#GET_LONG',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_LONGITUDE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_LONGITUDE).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#requestLocationUpdates(String, long, float, PendingIntent)',
      shortName: 'LM#REQ_LOC_UP#SLFP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_LOCATION_PARAM_INTENT',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_LOCATION_PARAM_INTENT).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'TelephonyManager#listen(PhoneStateListener, int)',
      shortName: 'TM#LIS#PI',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.LISTEN',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.LISTEN).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'BluetoothAdapter#startLeScan(LeScanCallback)',
      shortName: 'BA#STRT_LE_SC#L',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.START_LE_SCAN',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.START_LE_SCAN).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'android.location.Location#getLatitude()',
      shortName: 'LOC#GET_LAT',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_LATITUDE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_LATITUDE).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'TelephonyManager#getCellLocation()',
      shortName: 'TM#G_CELL_LOC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'CELL_INFO',
      lx_description: 'CellID',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_CELL_LOCATION',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_CELL_LOCATION).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'TelephonyManager#getAllCellInfo()',
      shortName: 'TM#G_ALL_CI',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'CELL_INFO',
      lx_description: 'CellID',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_ALL_CELL_INFO',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_ALL_CELL_INFO).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#requestSingleUpdate(Criteria, LocationListener, Looper)',
      shortName: 'LM#REQ_SIN_UP#CLL',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_SINGLE_PARAM_CRITERIA',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_SINGLE_PARAM_CRITERIA).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#requestLocationUpdates(long, float, Criteria, PendingIntent)',
      shortName: 'LM#REQ_LOC_UP#LFCP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'LOCATION',
      lx_description: '位置',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_LOCATION_PARAM_C_INTENT',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_LOCATION_PARAM_C_INTENT).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'location',
      api: 'BluetoothLeScanner#startScan(ScanCallback)',
      shortName: 'BLS#STRT_SC#S',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.START_SCAN_CALLBACK',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.START_SCAN_CALLBACK).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#removeUpdates(PendingIntent)',
      shortName: 'LM#RE_UP#P',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REMOVE_UPDATES_PEND_INTENT',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REMOVE_UPDATES_PEND_INTENT).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#requestLocationUpdates(String, long, float, LocationListener)',
      shortName: 'LM#REQ_LOC_UP#SLFL',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'LOCATION',
      lx_description: '位置',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_LOCATION_PARAM_LISTENER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.REQUEST_LOCATION_PARAM_LISTENER).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'location',
      api: 'CellIdentityWcdma#getCid()',
      shortName: 'CIW#G_CID',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.GET_CELL_WCDMA_CID',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.GET_CELL_WCDMA_CID).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'location',
      api: 'LocationManager#addGpsStatusListener(GpsStatus.Listener)',
      shortName: 'LM#AD_GPS_LIS',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '定位',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Location.NAME, ConstantModel.Location.ADD_GPS_STATUS_LISTENER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Location.NAME, ConstantModel.Location.ADD_GPS_STATUS_LISTENER).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'mediaFile',
      api: 'ContentResolver#query(Uri, String[], Bundle, CancellationSignal)',
      shortName: 'CR#QUERY_CON#U[SBC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '多媒体文件',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'MEDIA',
      lx_description: '多媒体文件',
      apiConstant: 'ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.QUERY_PARAM_BUNDLE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.QUERY_PARAM_BUNDLE).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'mediaFile',
      api: 'FileObserver#startWatching()',
      shortName: 'FO#STW',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '多媒体文件',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.FILE_START_WATCH',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.FILE_START_WATCH).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'mediaFile',
      api: 'ContentResolver#delete(Uri, String, String[])',
      shortName: 'CR#DELETE_FILE#US[S',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '多媒体文件',
      configStrategies: [
        'normal',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.DELETE_PARAM_SELECTION',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.DELETE_PARAM_SELECTION).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'mediaFile',
      api: 'ContentResolver#insert(Uri, ContentValues)',
      shortName: 'CR#INSERT_FILE#UC',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '多媒体文件',
      configStrategies: [
        'normal',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.INSERT_PARAM_VALUES',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.INSERT_PARAM_VALUES).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'mediaFile',
      api: 'ContentResolver#query(Uri, String[], String, String[], String)',
      shortName: 'CR#QUERY_CON#U[SS[SS',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '多媒体文件',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'MEDIA',
      lx_description: '多媒体文件',
      apiConstant: 'ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.QUERY_PARAM_SORT_ORDER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.QUERY_PARAM_SORT_ORDER).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'mediaFile',
      api: 'ContentResolver#query(Uri, String[], String, String[], String, CancellationSignal)',
      shortName: 'CR#QUERY_CON#U[SS[SSC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '多媒体文件',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'MEDIA',
      lx_description: '多媒体文件',
      apiConstant: 'ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.QUERY_PARAM_CANCEL_SIGNAL',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.QUERY_PARAM_CANCEL_SIGNAL).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'mediaFile',
      api: 'ContentResolver#registerContentObserver(Uri, boolean, ContentObserver)',
      shortName: 'CR#REG',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '多媒体文件',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.CR_REG',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.CR_REG).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'mediaFile',
      api: 'ContentResolver#delete(Uri, Bundle)',
      shortName: 'CR#DELETE_FILE#UB',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '多媒体文件',
      configStrategies: [
        'normal',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.DELETE_PARAM_BUNDLE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.DELETE_PARAM_BUNDLE).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'mediaFile',
      api: 'ContentResolver#insert(Uri, ContentValues, Bundle)',
      shortName: 'CR#INSERT_FILE#UCB',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '多媒体文件',
      configStrategies: [
        'normal',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.INSERT_PARAM_BUNDLE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.MediaFile.NAME, ConstantModel.MediaFile.INSERT_PARAM_BUNDLE).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'BluetoothAdapter#getAddress()',
      shortName: 'BA#G_ADDR',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'BLUETOOTH_MAC_ADDRESS',
      lx_description: '蓝牙MAC',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_ADDRESS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_ADDRESS).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'TelephonyManager#getDataNetworkType()',
      shortName: 'TM#G_DA_NET_TYPE',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_DATA_NETWORK_TYPE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_DATA_NETWORK_TYPE).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'WifiManager#startScan()',
      shortName: 'WM#STRT_SC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'NEARBY_WIFI',
      lx_description: '附近的WiFi',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.START_SCAN',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.START_SCAN).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'ConnectivityManager#getActiveNetworkInfo()',
      shortName: 'CM#G_ACT_NET_INFO',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_ACTIVE_NET_INFO',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_ACTIVE_NET_INFO).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'BluetoothAdapter#getName()',
      shortName: 'BA#G_BTNAME',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.BLUETOOTH_GET_NAME',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.BLUETOOTH_GET_NAME).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'NetworkInfo#getSubtype()',
      shortName: 'NI#G_SUB_TYPE',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'NETWORKTYPE',
      lx_description: '网络类型',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_SUB_TYPE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_SUB_TYPE).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'TelephonyManager#getNetworkType()',
      shortName: 'TM#G_NET_TYPE',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'NETWORKTYPE',
      lx_description: '网络类型',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_NETWORK_TYPE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_NETWORK_TYPE).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'InetAddress#getHostAddress()',
      shortName: 'IA#GET_H_A',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'IP_ADDRESS',
      lx_description: 'IP地址',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_HOST_ADDRESS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_HOST_ADDRESS).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'NetworkInterface#getInterfaceAddresses()',
      shortName: 'NI#G_IF_ADDR',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_INTERFACE_ADDRESS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_INTERFACE_ADDRESS).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'NetworkCapabilities#hasTransport(int)',
      shortName: 'NC#HAS_TRANS',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.HAS_TRANSPORT',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.HAS_TRANSPORT).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'WifiInfo#getIpAddress()',
      shortName: 'WI#G_IP_ADDR',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_IPADDR',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_IPADDR).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'NetworkInfo#getType()',
      shortName: 'NI#G_TYPE',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'NETWORKTYPE',
      lx_description: '网络类型',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_TYPE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_TYPE).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'NetworkInfo#getExtraInfo()',
      shortName: 'NI#GET_EXT_INFO',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'SSID',
      lx_description: 'SSID',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.NET_GET_EXTRA_INFO',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.NET_GET_EXTRA_INFO).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'WifiInfo#toString()',
      shortName: 'WI#TO_STR',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.WIFI_TO_STRING',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.WIFI_TO_STRING).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'NetworkInterface#getNetworkInterfaces()',
      shortName: 'NI#G_NET_INT',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_NETWORK_INTERFACES',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_NETWORK_INTERFACES).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'NetworkInfo#getTypeName()',
      shortName: 'NI#G_TY_NAME',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'NETWORKTYPE',
      lx_description: '网络类型',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_TYPE_NAME',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_TYPE_NAME).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'WifiInfo#getBSSID()',
      shortName: 'WI#G_BSSID',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'BSSID',
      lx_description: 'BSSID',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_BSSID',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_BSSID).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'NetworkInterface#getHardwareAddress()',
      shortName: 'NI#G_HW_ADDR',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'WIFI_MAC_ADDRESS',
      lx_description: 'Mac地址',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_HARDWARE_ADDRESS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_HARDWARE_ADDRESS).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'NetworkInterface#getInetAddresses()',
      shortName: 'NI#G_INET_ADDR',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'IP_ADDRESS',
      lx_description: 'IP 地址',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_INET_ADDRESS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_INET_ADDRESS).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'WifiManager#getScanResults()',
      shortName: 'WM#G_SC_RES',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'NEARBY_WIFI',
      lx_description: '附近的WiFi',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_SCAN_RESULTS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_SCAN_RESULTS).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'WifiManager#getDhcpInfo()',
      shortName: 'WM#G_D_INFO',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_DHCP_INFO',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_DHCP_INFO).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'WifiInfo#getMacAddress()',
      shortName: 'WI#G_MA_ADDR',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_storage',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'WIFI_MAC_ADDRESS',
      lx_description: 'Mac地址',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_MAC_ADDRESS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_MAC_ADDRESS).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_STORAGE).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'WifiManager#getConfiguredNetworks()',
      shortName: 'WM#G_CON_NET',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_CONFIGURE_NETWORKS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_CONFIGURE_NETWORKS).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'network',
      api: 'WifiInfo#getSSID()',
      shortName: 'WI#G_SSID',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'storage_storage',
        'ban_storage',
        'cacheOnly_storage',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '网络信息',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
        'storage',
      ],
      lx_module: 'SSID',
      lx_description: 'SSID',
      apiConstant: 'ConstantModel.Network.NAME, ConstantModel.Network.GET_SSID',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Network.NAME, ConstantModel.Network.GET_SSID).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'permission',
      api: 'Activity#requestPermissions(String[], int)',
      shortName: 'ACT#REQ_PER#SI',
      supportRules: [
        'normal_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '权限',
      configStrategies: [
        'normal',
      ],
      lx_module: 'requestPermissions',
      lx_description: '请求权限',
      apiConstant: 'ConstantModel.Permission.NAME, ConstantModel.Permission.REQUEST_PERMISSIONS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Permission.NAME, ConstantModel.Permission.REQUEST_PERMISSIONS).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'recorder',
      api: 'MediaRecorder#start()',
      shortName: 'MR#STRT',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '录音/语音',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'START_RECORD_VIDEO',
      lx_description: '开始录像',
      apiConstant: 'ConstantModel.Audio.NAME, ConstantModel.Audio.START',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Audio.NAME, ConstantModel.Audio.START).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'recorder',
      api: 'AudioRecord#startRecording(MediaSyncEvent)',
      shortName: 'AR#STRT_REC#M',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '录音/语音',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'START_RECORD_AUDIO',
      lx_description: '麦克风',
      apiConstant: 'ConstantModel.Audio.NAME, ConstantModel.Audio.START_RECORDING_MEDIA_SYNC_EVENT',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Audio.NAME, ConstantModel.Audio.START_RECORDING_MEDIA_SYNC_EVENT).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'recorder',
      api: 'MediaRecorder#setAudioSource(int)',
      shortName: 'MR#SET_AUD_SRC#I',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '录音/语音',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Audio.NAME, ConstantModel.Audio.SET_AUDIO_SOURCE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Audio.NAME, ConstantModel.Audio.SET_AUDIO_SOURCE).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'recorder',
      api: 'AudioRecord#startRecording()',
      shortName: 'AR#STRT_REC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '录音/语音',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'START_RECORD_AUDIO',
      lx_description: '麦克风',
      apiConstant: 'ConstantModel.Audio.NAME, ConstantModel.Audio.START_RECORDING',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Audio.NAME, ConstantModel.Audio.START_RECORDING).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'runtime',
      api: 'java.lang.Runtime#exec(String) getprop',
      shortName: 'R#P_A',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '命令行',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Runtime.NAME, ConstantModel.Runtime.EXEC_GETPROP_ALL',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Runtime.NAME, ConstantModel.Runtime.EXEC_GETPROP_ALL).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'runtime',
      api: 'java.lang.Runtime#exec(String) getprop serial',
      shortName: 'R#P_S',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '命令行',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'SERIAL',
      lx_description: '设备SN',
      apiConstant: 'ConstantModel.Runtime.NAME, ConstantModel.Runtime.EXEC_GETPROP_SERIAL',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Runtime.NAME, ConstantModel.Runtime.EXEC_GETPROP_SERIAL).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'runtime',
      api: 'java.lang.Runtime#exec(String) getprop model',
      shortName: 'R#P_M',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '命令行',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'PHONE_MODEL',
      lx_description: '手机型号',
      apiConstant: 'ConstantModel.Runtime.NAME, ConstantModel.Runtime.EXEC_GETPROP_MODEL',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Runtime.NAME, ConstantModel.Runtime.EXEC_GETPROP_MODEL).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'runtime',
      api: 'java.lang.Runtime#exec(String) pm list package',
      shortName: 'R#PM',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '命令行',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'PACKAGES',
      lx_description: '已安装应用列表',
      apiConstant: 'ConstantModel.Runtime.NAME, ConstantModel.Runtime.EXEC_PM',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Runtime.NAME, ConstantModel.Runtime.EXEC_PM).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'runtime',
      api: 'java.lang.Runtime#exec(String) ip',
      shortName: 'R#IP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '命令行',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Runtime.NAME, ConstantModel.Runtime.EXEC_IP',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Runtime.NAME, ConstantModel.Runtime.EXEC_IP).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#registerListener(SensorListener, int, int)',
      shortName: 'SM#RL#SII',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'SENSOR',
      lx_description: '传感器信息',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_LISTENER_PARAM_SII',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_LISTENER_PARAM_SII).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#getSensors()',
      shortName: 'SM#G_S',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.GET_SENSORS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.GET_SENSORS).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#getDefaultSensor(int, boolean)',
      shortName: 'SM#G_DS#IB',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.GET_DEFAULT_SENSOR_PARAM_IB',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.GET_DEFAULT_SENSOR_PARAM_IB).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'OrientationEventListener#enable()',
      shortName: 'OEL#EN#',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.ORIENTATION_EVENT_LISTENER_ENABLE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.ORIENTATION_EVENT_LISTENER_ENABLE).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#getDynamicSensorList(int)',
      shortName: 'SM#G_DSL#I',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.GET_DYNAMIC_SENSOR_LIST_PARAM_I',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.GET_DYNAMIC_SENSOR_LIST_PARAM_I).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#registerListener(SensorEventListener, android.hardware.Sensor, int, int, Handler)',
      shortName: 'SM#RL#SSIIH',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_LISTENER_PARAM_SSIIH',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_LISTENER_PARAM_SSIIH).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#getSensorList(int)',
      shortName: 'SM#G_SL#I',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.GET_SENSOR_LIST_PARAM_I',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.GET_SENSOR_LIST_PARAM_I).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#registerListener(SensorEventListener, android.hardware.Sensor, int, Handler)',
      shortName: 'SM#RL#SSIH',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_LISTENER_PARAM_SSIH',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_LISTENER_PARAM_SSIH).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#getDefaultSensor(int)',
      shortName: 'SM#G_DS#I',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.GET_DEFAULT_SENSOR_PARAM_I',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.GET_DEFAULT_SENSOR_PARAM_I).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#registerListener(SensorEventListener, android.hardware.Sensor, int, int)',
      shortName: 'SM#RL#SSII',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_LISTENER_PARAM_SSII',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_LISTENER_PARAM_SSII).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#requestTriggerSensor(TriggerEventListener, android.hardware.Sensor)',
      shortName: 'SM#RTL#TS',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_TRIGGER_LISTENER_PARAM_TS',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_TRIGGER_LISTENER_PARAM_TS).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#registerListener(SensorListener, int)',
      shortName: 'SM#RL#SI',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_LISTENER_PARAM_SI',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_LISTENER_PARAM_SI).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#registerDynamicSensorCallback(SensorManager.DynamicSensorCallback)',
      shortName: 'SM#RDSC#D',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_DYNAMIC_LISTENER_PARAM_D',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_DYNAMIC_LISTENER_PARAM_D).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#registerListener(SensorEventListener, android.hardware.Sensor, int)',
      shortName: 'SM#RL#SSI',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_LISTENER_PARAM_SSI',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_LISTENER_PARAM_SSI).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sensor',
      api: 'SensorManager#registerDynamicSensorCallback(SensorManager.DynamicSensorCallback, Handler)',
      shortName: 'SM#RDSC#DH',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'normal_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '传感器',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: '',
      lx_description: '',
      apiConstant: 'ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_DYNAMIC_LISTENER_PARAM_DH',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sensor.NAME, ConstantModel.Sensor.REGISTER_DYNAMIC_LISTENER_PARAM_DH).rule(GeneralRule.BACK_NORMAL_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 1,
      lx_show: false,
    },
    {
      module: 'sms',
      api: 'ContentResolver#query(Uri, String[], Bundle, CancellationSignal)',
      shortName: 'CR#QUERY_CON#U[SBC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '短信',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'SMS',
      lx_description: '短信',
      apiConstant: 'ConstantModel.Sms.NAME, ConstantModel.Sms.QUERY_PARAM_BUNDLE',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sms.NAME, ConstantModel.Sms.QUERY_PARAM_BUNDLE).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'sms',
      api: 'ContentResolver#query(Uri, String[], String, String[], String)',
      shortName: 'CR#QUERY_CON#U[SS[SS',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '短信',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'SMS',
      lx_description: '短信',
      apiConstant: 'ConstantModel.Sms.NAME, ConstantModel.Sms.QUERY_PARAM_SORT_ORDER',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sms.NAME, ConstantModel.Sms.QUERY_PARAM_SORT_ORDER).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'sms',
      api: 'ContentResolver#query(Uri, String[], String, String[], String, CancellationSignal)',
      shortName: 'CR#QUERY_CON#U[SS[SSC',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
        'cache_cache',
        'cache_normal',
        'ban_cache',
        'cacheOnly_normal',
        'cacheOnly_cacheOnly',
        'cacheOnly_cache',
      ],
      suggestRule: 'cacheOnly_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: true,
      description: '短信',
      configStrategies: [
        'normal',
        'ban',
        'cache_only',
        'memory',
      ],
      lx_module: 'SMS',
      lx_description: '短信',
      apiConstant: 'ConstantModel.Sms.NAME, ConstantModel.Sms.QUERY_PARAM_CANCEL_SIGNAL',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sms.NAME, ConstantModel.Sms.QUERY_PARAM_CANCEL_SIGNAL).rule(GeneralRule.BACK_CACHE_ONLY_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: true,
    },
    {
      module: 'sms',
      api: 'SmsManager#sendTextMessage(String, String, String, PendingIntent, PendingIntent)',
      shortName: 'SM#SE_TX_MESS#SSSPP',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '短信',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'SEND_SMS',
      lx_description: '发短信',
      apiConstant: 'ConstantModel.Sms.NAME, ConstantModel.Sms.SENT_TEXT_MESSAGE_SSSPP',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sms.NAME, ConstantModel.Sms.SENT_TEXT_MESSAGE_SSSPP).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
    {
      module: 'sms',
      api: 'SmsManager#sendTextMessage(String, String, String, PendingIntent, PendingIntent, long)',
      shortName: 'SM#SE_TX_MESS#SSSPPL',
      supportRules: [
        'normal_normal',
        'ban_ban',
        'ban_normal',
      ],
      suggestRule: 'ban_normal',
      supportHighFreq: true,
      suggestHighFreq: 'high',
      supportSilence: true,
      suggestSilence: 'TEN_SECOND',
      supportCacheTime: false,
      description: '短信',
      configStrategies: [
        'normal',
        'ban',
      ],
      lx_module: 'SEND_SMS',
      lx_description: '发短信',
      apiConstant: 'ConstantModel.Sms.NAME, ConstantModel.Sms.SENT_TEXT_MESSAGE_SSSPPL',
      suggestCode: 'PMonitor.getConfig().updateRuleForAPI(ConstantModel.Sms.NAME, ConstantModel.Sms.SENT_TEXT_MESSAGE_SSSPPL).rule(GeneralRule.BACK_BAN_AND_FRONT_NORMAL).submitRule();',
      lx_useflag: 0,
      lx_show: false,
    },
  ],
  SampleRate: [
    {
      scene: 'global',
      rate: 0.005,
      maxReport: 35,
    },
    {
      scene: 'before',
      rate: 0.5,
      maxReport: 10,
    },
    {
      scene: 'deny_retry',
      rate: 0.1,
      maxReport: 10,
    },
    {
      scene: 'illegal_scene',
      rate: 0.1,
      maxReport: 10,
    },
    {
      scene: 'mod_no_perm',
      rate: 0.2,
      maxReport: 15,
    },
    {
      scene: 'back',
      rate: 0.2,
      maxReport: 15,
    },
    {
      scene: 'silence',
      rate: 0.2,
      maxReport: 15,
    },
    {
      scene: 'high_freq',
      rate: 0.2,
      maxReport: 15,
    },
    {
      scene: 'func_invoke_user',
      rate: 0.001,
      maxReport: 30,
    },
    {
      scene: 'func_invoke_api',
      rate: 0.001,
      maxReport: 0,
    },
    {
      scene: 'func_app_download',
      rate: 0.001,
      maxReport: 5,
    },
    {
      scene: 'func_auto_monitor',
      rate: 0.001,
      maxReport: 5,
    },
    {
      scene: 'func_dynamic_resource',
      rate: 0.001,
      maxReport: 0,
    },
    {
      scene: 'func_receiver_monitor',
      rate: 0.001,
      maxReport: 2,
    },
    {
      scene: 'func_screenshot_monitor',
      rate: 0.001,
      maxReport: 2,
    },
    {
      scene: 'func_traffic_event',
      rate: 0.01,
      maxReport: 5,
    },
    {
      scene: 'func_traffic_user',
      rate: 0.001,
      maxReport: 30,
    },
  ],
  HighFreq: [
    {
      freq: 'lower',
      description: '24小时2次调用认为是高频调用，兜底使用前台规则',
    },
    {
      freq: 'low',
      description: '10分钟20次调用认为是高频调用，兜底使用前台规则',
    },
    {
      freq: 'middle',
      description: '1分钟10次调用认为是高频调用，兜底使用前台规则',
    },
    {
      freq: 'high',
      description: '10秒10次调用认为是高频调用，兜底使用前台规则',
    },
    {
      freq: 'higher',
      description: '10秒60次调用认为是高频调用，兜底使用前台规则',
    },
  ],
  Silence: [
    {
      time: 'five_second',
      description: '用户无操作5秒后有调用认为是静默调用，兜底使用前台规则',
    },
    {
      time: 'ten_second',
      description: '用户无操作10秒后有调用认为是静默调用，兜底使用前台规则',
    },
    {
      time: 'quarter_minute',
      description: '用户无操作15秒后有调用认为是静默调用，兜底使用前台规则',
    },
    {
      time: 'half_minute',
      description: '用户无操作30秒后有调用认为是静默调用，兜底使用前台规则',
    },
    {
      time: 'one_minute',
      description: '用户无操作1分钟后有调用认为是静默调用，兜底使用前台规则',
    },
  ],
  CacheTime: [
    {
      time: 'one_minute',
      description: '缓存有效时长1分钟',
    },
    {
      time: 'five_minute',
      description: '缓存有效时长5分钟',
    },
    {
      time: 'quarter_hour',
      description: '缓存有效时长15分钟',
    },
    {
      time: 'one_hour',
      description: '缓存有效时长1小时',
    },
    {
      time: 'one_day',
      description: '缓存有效时长1天',
    },
    {
      time: 'always',
      description: '内存缓存进程声明周期有效,持久化缓存长期有效,',
    },
  ],
  General: {
    Strategy: {
      ban_ban: '隐私前禁止访问，后台禁止访问，前台禁止访问',
      ban_cache: '隐私协议未同意前禁止调用，后台禁止调用，前台使用内存缓存',
      ban_normal: '隐私协议未同意前禁止调用，后台禁止调用，前台直接调用',
      ban_storage: '隐私协议未同意前禁止调用，后台禁止调用，前台使用持久化缓存',
      cacheOnly_cache: '隐私协议未同意前禁止调用，后台使用内存缓存(无缓存返回默认值)，前台使用内存缓存',
      cacheOnly_normal: '隐私协议未同意前禁止调用，后台使用内存缓存(无缓存返回默认值)，前台直接调用',
      cacheOnly_cacheOnly: '隐私协议未同意前禁止调用，后台使用内存缓存(无缓存返回默认值)，前台使用内存缓存(无缓存返回默认值)',
      cache_cache: '隐私协议未同意前禁止调用，后台使用内存缓存，前台使用内存缓存',
      normal_normal: '隐私协议未同意前禁止调用，后台直接调用，前台直接调用',
      storage_storage: '隐私协议未同意前禁止调用，后台使用持久化缓存，前台使用持久化缓存',
      cacheOnly_storage: '隐私协议未同意前禁止调用，后台使用内存缓存(无缓存返回默认值)，前台使用持久化缓存',
      cache_normal: '隐私协议未同意前禁止调用，后台使用内存缓存，前台直接调用',
    },
    HighFreq: {
      lower: '24小时2次调用认为是高频调用，兜底使用前台规则',
      low: '10分钟20次调用认为是高频调用，兜底使用前台规则',
      middle: '1分钟10次调用认为是高频调用，兜底使用前台规则',
      high: '10秒10次调用认为是高频调用，兜底使用前台规则',
      higher: '10秒60次调用认为是高频调用，兜底使用前台规则',
    },
    Scene: {
      global: '全局(用户)抽样',
      before: '隐私协议未同意前调用场景',
      back: '后台调用场景',
      high_freq: '高频调用场景',
      illegal_scene: '非法页面调用场景',
      silence: '静默调用场景',
      deny_retry: '无权限调用场景',
      func_invoke: '函数调用分析场景',
    },
    Title: {
      api: '合规全局配置说明：\n(默认)NORMAL_NORMAL_NORMAL： 所有API的策略为: 未同意隐私前正常调用,后台正常调用,前台正常调用,高频10s10次且正常调用,静默5秒且正常调用\nBAN_NORMAL_NORMAL：所有API的策略为: 未同意隐私前禁止调用,后台正常调用,前台正常调用,高频10s10次且正常调用,静默5秒且正常调用\nBAN_BAN_NORMAL：所有API的策略为: 未同意隐私前禁止调用,后台禁止调用,前台正常调用,高频10s10次且正常调用,静默5秒且正常调用\nCOMPLIANCE_TEST：见下表格中的测试配置规则,高频10s10次且和前台兜底一致,静默5秒且和前台兜底一致',
    },
    CacheTime: {
      one_minute: '缓存有效时长1分钟',
      five_minute: '缓存有效时长5分钟',
      quarter_hour: '缓存有效时长15分钟',
      one_hour: '缓存有效时长1小时',
      one_day: '缓存有效时长1天',
      always: '内存缓存进程声明周期有效,持久化缓存长期有效,',
    },
    Silence: {
      five_second: '用户无操作5秒后有调用认为是静默调用，兜底使用前台规则',
      ten_second: '用户无操作10秒后有调用认为是静默调用，兜底使用前台规则',
      quarter_minute: '用户无操作15秒后有调用认为是静默调用，兜底使用前台规则',
      half_minute: '用户无操作30秒后有调用认为是静默调用，兜底使用前台规则',
      one_minute: '用户无操作1分钟后有调用认为是静默调用，兜底使用前台规则',
    },
  },
};
